import { useMutation } from "react-query";

import { $ok } from "foundation-ts/commons";
import { Nullable } from "foundation-ts/types";

import { useAuthContext } from "@hooks/useAuthContext";
import { authenticate, getUserUuid } from "@services/authentication.service";
import { getUserProfile } from "@services/users.service";
import { optlog } from "@utils/functions";

export const useLogin = () => {
    const { setStandardUser, setPendingAdmin } = useAuthContext();

    return useMutation(
        ({ username, password, admin, captchaToken }: { username: string; password: string; admin: Nullable<boolean>, captchaToken: string }) => {
            return authenticate(username, password, admin, captchaToken);
        },
        {
            onSuccess: async (_data, variables, _context) => {
                try {
                    const uid = getUserUuid() ;
                    if (!$ok(uid)) { 
                        optlog(`Unable to find user id`);
                        throw new Error("401");
                    }

                    if (!!variables.admin) {
                        setPendingAdmin(uid!);
                    } else {
                        setStandardUser(await getUserProfile(uid!));
                    }
                } catch (e) {
                    throw new Error("401");
                }
            },
            onError: (error) => {
                optlog(`Login error: ${error}`);
                throw error;
            },
        }
    );
}